import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportingDataService } from '../shared/services/reporting-data.service';

@Component({
  selector: 'app-reporting-operations',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './reporting-operations.component.html',
  styleUrl: './reporting-operations.component.scss'
})
export class ReportingOperationsComponent {

  get kpiCards() { return this.dataService.operationsKpis; }
  get operationsNamcRows() { return this.dataService.operationsNamcRows; }
  get trendConfig() { return this.dataService.operationsTrendConfig; }
  readonly pageFilters = ['Last 30 Days', 'All Plants', 'All Equipment'];

  readonly downtimeDistribution = [
    { label: 'Equipment', pct: 44, color: '#1769aa' },
    { label: 'Tooling',   pct: 28, color: '#ee7c24' },
    { label: 'Process',   pct: 16, color: '#31a36f' },
    { label: 'Other',     pct: 12, color: '#93a7ba' }
  ];

  selectedNamc = 'ALL';
  selectedShopType = 'ALL';

  get filteredRows() {
    return this.selectedNamc === 'ALL'
      ? this.operationsNamcRows
      : this.operationsNamcRows.filter(r => r.namc === this.selectedNamc);
  }

  trackByName(_: number, row: { namc: string }): string { return row.namc; }
  trackByIndex(index: number): number { return index; }

  constructor(private readonly dataService: ReportingDataService) {}
}
